import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";

function Myorders() {
  return (
    <>
      <Header />
      <PageHeader pagename="my orders" />
      {/* My Orders Section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">My Orders</h3>
                    </div>
                  </div>
                </div>
                <div className="order-back">
                  <div className="row ">
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Order Number</h5>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Date</h5>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Payment Status</h5>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Total</h5>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Delivery Status</h5>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-head">
                        <h5 className="primary-color">Details</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tr-dv">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">#00098796</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">25/12/24</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Paid</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">$45.00</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Delivered</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <Link to="/order-detail">
                        <button className="btn-all" style={{ width: "90%" }}>
                          View Detail
                        </button>
                        </Link>
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tr-dv">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">#00098796</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">25/12/24</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Paid</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">$45.00</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Delivered</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <button className="btn-all" style={{ width: "90%" }}>
                          View Detail
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tr-dv">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">#00098796</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">25/12/24</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Paid</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">$45.00</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Delivered</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <button className="btn-all" style={{ width: "90%" }}>
                          View Detail
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tr-dv">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">#00098796</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">25/12/24</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Paid</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="primary-color">$45.00</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <p className="secondary-color back-white">Delivered</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="order-para">
                        <button className="btn-all" style={{ width: "90%" }}>
                          View Detail
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="myorder-pagiantion">
                  <nav aria-label="...">
                    <ul className="pagination pagination-sm">
                      {/* <li class="page-item active" aria-current="page">
                        <span class="page-link page-item">1</span>
                      </li> */}
                      <li className="page-item">
                        <a className="page-link" href="#">
                          1
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          3
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          4
                        </a>
                      </li>
                      <li className="page-item">
                        .....
                      </li>
                      <li className="page-item">
                      <a className="page-link" href="#">
                          15
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======================= */}

      <Footer />
    </>
  );
}

export default Myorders;
